import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { LocationWithName } from 'app/models/locations';
import { FeatureToggleService } from 'app/services/feature-toggle.service';
import { Observable, Subject, Subscription } from 'rxjs';
import { updateShouldCloseModal } from 'user/actions/user-profile.actions';
import { GetItRapidoOptionsForm, HoldNeededDateRapidoForm, Volume } from 'user/models/get-it';
import { getShouldCloseModal, isLoading, UserState } from 'user/reducers/user.reducer';

@Component({
  selector: 'app-get-it-rapido-options-dialog',
  templateUrl: './get-it-rapido-options-dialog.component.html',
  styleUrls: ['./get-it-rapido-options-dialog.component.scss']
})
export class GetItRapidoOptionsDialogComponent implements OnInit {
  @Input() public pickupLocations: LocationWithName[];
  @Input() public volumes: Volume[];
  @Input() public selectedLocationCode: string;
  @Input() public selectedVolumeCode: string;
  @Input() public note: string = '';

  public getItForm: FormGroup<GetItRapidoOptionsForm>;
  public isLoading$: Observable<boolean>;
  public formDataSubject = new Subject<any>();
  public isCRI = false;

  private readonly subscription = new Subscription();

  constructor(
    private readonly activeModal: NgbActiveModal,
    private readonly store: Store<UserState>,
    private readonly fb: FormBuilder,
    private readonly featureToggleService: FeatureToggleService,
  ) {}

  public ngOnInit() {
    this.isLoading$ = this.store.select(isLoading);
    this.isCRI = this.featureToggleService.getToggles()['licenseCentralRequest'];
    this.getItForm = this.fb.group<GetItRapidoOptionsForm>({
      pickupLocation: this.fb.control<string>(
        this.selectedLocationCode,
        Validators.required
      ),
      volume: this.fb.control<string>(
        this.selectedVolumeCode,
        Validators.required
      ),
      note: this.fb.control<string>(
        this.note
      ),
    });
  }

  public changePickupLocation(code: string) {}

  public changeVolume(code: string) {}

  public changeLimitToAvailable(code: string) {}

  get isFormDisabled(): boolean {
    return false;
  }

  get noteControl(): AbstractControl {
    return this.getItForm.get('note');
  }

  public onClose() {
    this.formDataSubject.error({});
    this.store.dispatch(updateShouldCloseModal({ errorMessage: '' }));
    this.activeModal.dismiss();
  }

  public onReset() {
    this.getItForm.reset();
  }

  public onSubmit() {
    // eslint-disable-next-line no-console
    console.debug('this.getItForm.getRawValue()',this.getItForm.getRawValue());
    this.formDataSubject.next(this.getItForm.getRawValue());
    this.subscription.add(
      this.store.select(getShouldCloseModal).subscribe((shouldCloseModal) => {
        if (shouldCloseModal) {
          this.activeModal.close();
        }
      })
    );
  }
}